"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tab = {
    baseStyle: {
        root: {
            flex: 1,
        },
        tablist: {
            width: 'fit-content',
        },
        tabpanels: {
            flex: 1,
        },
        tabpanel: {
            flex: 1,
            padding: 0,
        },
    },
    parts: ['tablist', 'tab'],
    variants: {
        line: {
            tablist: {
                borderColor: 'gray.200',
                marginY: 2,
            },
            tab: {
                borderRadius: '0',
                color: 'blueGray.800',
                fontWeight: 'bold',
                _selected: {
                    color: 'blue.600',
                },
            },
        },
        guide: {
            tablist: {
                borderBottom: '1px solid',
                borderColor: 'inherit',
                marginBottom: '-1px',
            },
            tab: {
                borderTopLeftRadius: 'md',
                borderTopRightRadius: 'md',
                border: 'solid 1px',
                borderColor: 'transparent',
                marginBottom: '-1px',
                _selected: {
                    backgroundColor: 'var(--chakra-colors-gray-100)',
                    border: 'solid 1px silver',
                    color: 'var(--chakra-colors-blue-600)',
                    borderBottomColor: 'transparent',
                },
            },
        },
    },
};
exports.default = Tab;
